import { useCallback } from 'react';
import { Button, ButtonSize } from '@shipengine/giger';
import { useSdk } from '@packlink/packlink-sdk-provider';
import { jsx } from '@emotion/react/jsx-runtime';
import { addBreadcrumb, logApliClientError } from '../../../utils/Logger.js';
import { LoggerPaymentBreadcrumb } from '../../../types/types.js';

const CreditCardVault = _ref => {
  let {
    isPaymentBlocked = false,
    buttonLoading = false,
    buttonText,
    creditCard,
    spinner,
    onCheckForExternalError,
    onPay,
    onVerificationStart,
    onVerificationError
  } = _ref;
  const sdk = useSdk();
  const onLookupNonceRequest = useCallback(() => {
    return sdk.v1.billing.getNonce(creditCard).then(data => {
      addBreadcrumb(LoggerPaymentBreadcrumb.PAYMENT, 'Get Payment nonce');
      return data.toJSON();
    }).catch(error => {
      logApliClientError(error);
      throw error;
    });
  }, [sdk, creditCard]);
  const requestCreditCardNonce = () => {
    if (isPaymentBlocked) {
      onCheckForExternalError === null || onCheckForExternalError === void 0 ? void 0 : onCheckForExternalError();
      return;
    }
    onVerificationStart();
    onLookupNonceRequest().then(onPay).catch(onVerificationError);
  };
  return jsx(Button, {
    isFullWidth: true,
    isLoading: buttonLoading,
    size: ButtonSize.LARGE,
    spinner: spinner,
    onClick: requestCreditCardNonce,
    children: buttonText
  });
};

export { CreditCardVault };
//# sourceMappingURL=CreditCardVault.js.map
